module.exports = __webpack_public_path__ + "media/icons/arrow-btn-baner@2x-9ecbad1a.png";